import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import Bs4Kartoteka from '../Bs4Kartoteka'
import Bs4MainDispatch from '../Bs4MainDispatch';
import Bs4DataProvider from './Bs4DataProvider';
import Bs4ReportGeneric from './Bs4ReportGeneric';
import Bs4Criteria from './Bs4Criteria'
import Bs4CriteriaSummary from './Bs4CriteriaSummary'
import Bs4I18N from '../Bs4I18N';
import { Typography } from '@mui/material';
import { UxAccordion, getBoxSx, useStateUxTemplate } from '../Bs4Theme/Bs4UxTemplates';

const TYPE_BS4REPORTTYPE46 = 'type_Bs4Reporttype46';

//oś czasu
export default class Bs4ReportType46 extends Bs4ReportGeneric {
  static TOME_LINE_POSITION_CENTER = 'center';
  static TOME_LINE_POSITION_LEFT = 'left';
  static TOME_LINE_POSITION_RIGHT = 'right';  
  static TOME_LINE_POSITION_ALTERNATE = 'alternate';

  createModel() {
    super.createModel();    
    this.bs4DataProvider = new Bs4DataProvider(this.props);
    this.bs4DataProvider.resetBs4PageProps(); 
  }

  /////////////////// form field /////////////////////////////
  getValue() {
    return null;
  }

  resetOriginalValue() {
  }  

  isDifferentValues (oldValue, newVaue) {
    return false;
  }

  clear() {
  }
  //////////////////////////////////////////////////////////

  defaultUxTemplate = {
    class: 189,
    name: 'Bs4ReportType46',
    body: {
      Report46: {
        panel: {
          backgroundColor: "rgba(255, 255, 255, 1)",
          padding: 1,
          elevation: 2,
          borderRadius: 2,
        },         
        date: {
          // backgroundColor: "rgba(255, 255, 255, 1)",
          // padding: 1,
          // elevation: 2,
          // borderRadius: 2,
          // fontSize: 0,
        },         
        layout: {
          spacing: 1,
          position: Bs4ReportType46.TOME_LINE_POSITION_RIGHT,
        },
        icon: {
          colored: false,
          box: {
            //fontSize: '14px',
          },
        },
      },        
    }
  };

  getUxTemplateEditor = (uxEditor) => {    

    return [{
      label: Bs4I18N.getTT('Report46', 'Report46', 'Bs4ReportType46'),
      getUxTemplate: () => this.uxTemplate,
      setUxTemplate: this.setUxTemplate,
      types: [TYPE_BS4REPORTTYPE46],
      Content: (props) => {
        const [expanded, setExpanded] = React.useState('Panel');
        const uxBody = this.uxTemplate.body.Report46;
        const type = TYPE_BS4REPORTTYPE46;
      
        const handleChange = (panel) => (event, isExpanded) => {
          // console.log('... UxAccordion .Main. .handleChange.', panel, isExpanded)
          setExpanded(isExpanded ? panel : false);
        }

        return (
          <Box p={1}>
            <UxAccordion 
              label={'Layout'} 
              types={[TYPE_BS4REPORTTYPE46]}
              expanded={expanded} 
              onChange={handleChange} 
              onReset={() => {
                this.uxTemplate.body.Report46.layout = JSON.parse(JSON.stringify(this.defaultUxTemplate.body.Report46.layout));
              }}
            >
              <Box display='flex' flexDirection='column' p={1.5}>
                <uxEditor.ViewCssSelect types={type} value={uxBody.layout} name='position' options={[Bs4ReportType46.TOME_LINE_POSITION_LEFT, Bs4ReportType46.TOME_LINE_POSITION_RIGHT, Bs4ReportType46.TOME_LINE_POSITION_ALTERNATE]}/>
                <uxEditor.ViewCssNumber types={type} value={uxBody.layout} name='spacing'/>
                <uxEditor.ViewCssText types={type} value={uxBody.layout} name='padding'/>
              </Box>
            </UxAccordion>
            <UxAccordion 
              label={'Date'} 
              types={[TYPE_BS4REPORTTYPE46]}
              expanded={expanded} 
              onChange={handleChange} 
              onReset={() => {
                this.uxTemplate.body.Report46.date = JSON.parse(JSON.stringify(this.defaultUxTemplate.body.Report46.date));
              }}
            >
              <Box display='flex' flexDirection='column' p={1.5}>
                <uxEditor.ViewCssCheckbox types={type} value={uxBody.date} name='colored'/>
                {/* <Stack direction="row" justifyContent="space-around" alignItems="center" spacing={1}>
                  <uxEditor.ViewCssColor types={type} value={uxBody.date} name='color' title='Tekst'/>
                  <uxEditor.ViewCssColor types={type} value={uxBody.date} name='backgroundColor' title='Tło'/>
                  <uxEditor.ViewCssColor types={type} value={uxBody.date} name='borderColor' title='Ramka'/>
                </Stack>                                  
                
                <uxEditor.ViewCssShadow types={type} value={uxBody.date} name='elevation'/>
                <uxEditor.ViewCssText types={type} value={uxBody.date} name='borderRadius'/>
                <uxEditor.ViewCssText types={type} value={uxBody.date} name='borderWidth'/>

                <uxEditor.ViewCssText types={type} value={uxBody.date} name='width'/>
                <uxEditor.ViewCssText types={type} value={uxBody.date} name='margin'/>
                <uxEditor.ViewCssText types={type} value={uxBody.date} name='padding'/> */}

                <uxEditor.ViewCssText types={type} value={uxBody.date} name='fontSize'/>
                <uxEditor.ViewCssTypography types={type} value={uxBody.date} name='variant'/>                
              </Box>
            </UxAccordion>            
            <UxAccordion 
              label={'Panel'} 
              types={[TYPE_BS4REPORTTYPE46]}
              expanded={expanded} 
              onChange={handleChange} 
              onReset={() => {
                this.uxTemplate.body.Report46.panel = JSON.parse(JSON.stringify(this.defaultUxTemplate.body.Report46.panel));
              }}
            >
              <Box display='flex' flexDirection='column' p={1.5}>
                <Stack direction="row" justifyContent="space-around" alignItems="center" spacing={1}>
                  <uxEditor.ViewCssColor types={type} value={uxBody.panel} name='color' title='Tekst'/>
                  <uxEditor.ViewCssColor types={type} value={uxBody.panel} name='backgroundColor' title='Tło'/>
                  <uxEditor.ViewCssColor types={type} value={uxBody.panel} name='borderColor' title='Ramka'/>
                </Stack>                                  
                
                <uxEditor.ViewCssShadow types={type} value={uxBody.panel} name='elevation'/>
                <uxEditor.ViewCssText types={type} value={uxBody.panel} name='borderRadius'/>
                <uxEditor.ViewCssText types={type} value={uxBody.panel} name='borderWidth'/>

                <uxEditor.ViewCssText types={type} value={uxBody.panel} name='width'/>
                <uxEditor.ViewCssText types={type} value={uxBody.panel} name='margin'/>
                <uxEditor.ViewCssText types={type} value={uxBody.panel} name='padding'/>
              </Box>
            </UxAccordion>
            <UxAccordion 
              label={'Icon'} 
              types={[TYPE_BS4REPORTTYPE46]}
              expanded={expanded} 
              onChange={handleChange} 
              onReset={() => this.uxTemplate.body.Report46.icon = JSON.parse(JSON.stringify(this.defaultUxTemplate.body.Report46.icon))}
            >
              <Box display='flex' flexDirection='column' p={1.5}>
                <uxEditor.ViewCssCheckbox types={type} value={uxBody.icon} name='colored'/>
                <Stack direction="row" justifyContent="space-around" alignItems="center" spacing={1}>
                  <uxEditor.ViewCssColor types={type} value={uxBody.icon.box} name='color' title='Tekst'/>
                  <uxEditor.ViewCssColor types={type} value={uxBody.icon.box} name='backgroundColor' title='Tło'/>
                  <uxEditor.ViewCssColor types={type} value={uxBody.icon.box} name='borderColor' title='Ramka'/>
                </Stack>                                  
                
                <uxEditor.ViewCssShadow types={type} value={uxBody.icon.box} name='elevation'/>
                <uxEditor.ViewCssText types={type} value={uxBody.icon.box} name='borderRadius'/>
                <uxEditor.ViewCssText types={type} value={uxBody.icon.box} name='borderWidth'/>
                
                <uxEditor.ViewCssText types={type} value={uxBody.icon.box} name='fontSize'/>
                <uxEditor.ViewCssText types={type} value={uxBody.icon.box} name='margin'/>
                <uxEditor.ViewCssText types={type} value={uxBody.icon.box} name='padding'/>                                

              </Box>
            </UxAccordion>
          </Box>
        )
      },
    }];
  }

  runListOption(item, rowId) { 
		const details = { 
			reportOptionId: item?.bs4Id, 
			selectedRows: [rowId],
			storeData: this.getData(),
      ukladKryt: JSON.stringify(this.fetchCriteriaVals()),
			ukladKolumn: this.packColumnLayout(),
			ukladSort: JSON.stringify(this.gridSortToHidden()),      
      currFormId: this.formId,  
		}		

		Bs4MainDispatch.commandParser('Bs4ReportOption', details, this.bs4KartotekaId);
    this.atrybProgressbar(item);
	}

  onMenuClick = (item) => {
    this.runListOption(item);
  }

  fetchCriteriaVals() {
		const filterCriteria = this.defaultCriteriaVals();    				
		if (this.remembersettings) filterCriteria.remembersettings = 1;
		//filterCriteria.newGridDesign = this.packColumnLayout();	// zapamietany uklad kolumn
		return filterCriteria;
	}

  reload = () => {
    this.bs4DataProvider.resetBs4PageProps();
    this.bs4DataProvider.fetchMore()
  }

  isEven = (n) => {
    return n % 2 === 0;
  }

  verticalAlign = 'baseline';
  cellBorder = 'none';

  ViewRowOppositeContent = (props) => {
    const report = this;    
    const theme = useTheme();
    const {dateTimeStamp} = useStateUxTemplate(TYPE_BS4REPORTTYPE46);

    const side = React.useMemo(() => {
      return props.side === Bs4ReportType46.TOME_LINE_POSITION_RIGHT ? Bs4ReportType46.TOME_LINE_POSITION_LEFT : Bs4ReportType46.TOME_LINE_POSITION_RIGHT;
    }, [props.side]);

    const boxSx = React.useMemo(() => {      
      const boxUx = getBoxSx(this.uxTemplate?.body?.Report46?.date , theme);
      const boxSx = {              
        justifySelf: side === Bs4ReportType46.TOME_LINE_POSITION_LEFT ? 'end' : 'start',
        textAlign: side, 
        overflowWrap: 'anywhere',        
      }

      if (boxUx.fontSize) boxSx.fontSize = boxUx.fontSize;

      if (this.uxTemplate?.body?.Report46?.date?.colored) {
        const xx555 = getBoxSx(props.row.xx555, theme);
        if (xx555.color) boxSx.color = xx555.color;
      }      
          
      if (!boxSx.margin) {
        const spacing = this.uxTemplate?.body?.Report46?.layout?.spacing || 0;
        if (side === Bs4ReportType46.TOME_LINE_POSITION_LEFT) boxSx.mr = spacing;
        else boxSx.ml = spacing;
        boxSx.mb = spacing;
      }      

      // console.log('...Bs4ReportType46...ViewRowOppositeContent', boxUx, getBoxSx(props.row.xx555, theme), boxSx);
      
      return boxSx;
    }, [dateTimeStamp, side]);

    const variant = React.useMemo(() => {
      return this.uxTemplate?.body?.Report46?.date.variant || 'body1';
    }, [dateTimeStamp])

    return (
      <Typography gridColumn={props.gridColumn} gridRow='1/2' sx={boxSx} variant={variant}>
        <Box component='span' dangerouslySetInnerHTML={{__html: Boolean(props.row.kk333) ? props.row.kk333 : props.row.kk332}} />  
      </Typography>
    )
  }

  VievIcon = (props) => {    
    const theme = useTheme();
    const {dateTimeStamp} = useStateUxTemplate(TYPE_BS4REPORTTYPE46);
    const icon = this.uxTemplate?.body?.Report46?.icon;
    const boxSx = React.useMemo(() => {
      const boxSx = getBoxSx(this.uxTemplate?.body?.Report46?.icon?.box, theme);
      if (this.uxTemplate?.body?.Report46?.icon?.colored) {
        return {...boxSx, ...getBoxSx(props.row.xx555, theme)};
      }      
      return boxSx;
    }, [theme, dateTimeStamp] );
    const size = React.useMemo(() => {return this.uxTemplate?.body?.Report46?.icon?.size}, [dateTimeStamp]);

    return (
      <Box
        sx={{          
          aspectRatio: 1,
          color: props?.timeLineColor,
          ...boxSx,
          textAlign: 'center',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',        
        }}
        className={props?.row?.icon || 'fa-solid fa-circle'}
      />      
    )
  }

  ViewRowSeparator = (props) => {    
    const report = this;
    const timeLineColor = 'rgba(0, 0, 0, 0.3)';   

    return (
        <Stack         
          gridColumn={props.gridColumn} gridRow='1/2' sx={{height: '100%', border: report.cellBorder}}
          direction="column" 
          justifyContent="flex-start"
          alignItems="center"
        >
          <report.VievIcon {...props} timeLineColor={timeLineColor}/>
          <Box flex={1} width={2} backgroundColor={timeLineColor}/>
        </Stack>
    )
  }

  ViewRowContent = (props) => {
    const report = this;
    const theme = useTheme();
    const {dateTimeStamp} = useStateUxTemplate(TYPE_BS4REPORTTYPE46);

    const side = React.useMemo(() => {
      return props.side === Bs4ReportType46.TOME_LINE_POSITION_RIGHT ? Bs4ReportType46.TOME_LINE_POSITION_LEFT : Bs4ReportType46.TOME_LINE_POSITION_RIGHT;
    }, [props.side]);

    const boxSx = React.useMemo(() => {      
      const boxSx = {        
        ...getBoxSx(this.uxTemplate?.body?.Report46?.panel , theme),
        ...getBoxSx(props.row.xx555, theme),
        justifySelf: side === Bs4ReportType46.TOME_LINE_POSITION_LEFT ? 'start' : 'end',
        textAlign: side, 
        overflowWrap: 'anywhere',
      }
      
      if (!boxSx.margin) {
        const spacing = this.uxTemplate?.body?.Report46?.layout?.spacing || 0;
        if (side === Bs4ReportType46.TOME_LINE_POSITION_LEFT) boxSx.ml = spacing;
        else boxSx.mr = spacing;
        boxSx.mb = spacing;
      }

      return boxSx;
    }, [dateTimeStamp, side, theme, props.row.xx555]);    
    
    const handleClick = (event) => {
      Bs4MainDispatch.commandParserAfter(this.bs4KartotekaId);
      if(this.getPageParam('row_active_click')) {
        console.log('..row click.2.', event, props.row, )
        Bs4MainDispatch.commandParser('Bs4RowClick',{ rowObjectId: props.row.id, currFormId: this.formId }, this.bs4KartotekaId);
      }	
    }            

    return (      
      <Box 
        gridColumn={props.gridColumn} gridRow='1/2'
        sx={boxSx} 
        onClick={handleClick}
        dangerouslySetInnerHTML={{__html: props.row.kk331}}
      />      
    )
  }

  ViewRow = (props) => {  
    const report = this;
    const {dateTimeStamp} = useStateUxTemplate(TYPE_BS4REPORTTYPE46);

    const side = React.useMemo(() => {
      let side = this.uxTemplate?.body?.Report46?.layout?.position || Bs4ReportType46.TOME_LINE_POSITION_RIGHT;
      if (side === Bs4ReportType46.TOME_LINE_POSITION_ALTERNATE) {
        side = this.isEven(props.index) ? Bs4ReportType46.TOME_LINE_POSITION_LEFT : Bs4ReportType46.TOME_LINE_POSITION_RIGHT;
      }
      
      if (props.row?.show === Bs4ReportType46.TOME_LINE_POSITION_LEFT) {
        if (side === Bs4ReportType46.TOME_LINE_POSITION_RIGHT) side = Bs4ReportType46.TOME_LINE_POSITION_LEFT;
        else side = Bs4ReportType46.TOME_LINE_POSITION_RIGHT;
      }
      return side;
    }, [dateTimeStamp, props.index, props.row?.show]);    

    const gridColumnContent = side === Bs4ReportType46.TOME_LINE_POSITION_LEFT ? '1/2' : '3/4';
    const gridColumnSeparator = '2/3';
    const gridColumnOppositeContent = side === Bs4ReportType46.TOME_LINE_POSITION_LEFT ? '3/4' : '1/2';    
    
    return (
      <Box
        gridColumn='1/4'
        display='grid'
        gridTemplateColumns='subgrid'
        gridTemplateRows='auto'
        alignItems={'baseline'}
      >
        <report.ViewRowContent {...props} side={side} gridColumn={gridColumnContent}/>
        <report.ViewRowSeparator {...props} side={side} gridColumn={gridColumnSeparator}/>
        <report.ViewRowOppositeContent {...props} side={side} gridColumn={gridColumnOppositeContent}/>
      </Box>
    )
  }

  ViewComponent = React.forwardRef((props, ref) => {
    const report = this;
    const theme = useTheme();
    const [data, setData] = React.useState([])

    const {dateTimeStamp} = useStateUxTemplate(TYPE_BS4REPORTTYPE46);    

    const boxSx = React.useMemo(() => {
      const tmpSx = {        
        ...getBoxSx(this.uxTemplate?.body?.Report46?.layout , theme),
      }
      delete tmpSx.spacing;
      return tmpSx;
    }, [dateTimeStamp, theme]);    

    // console.log('...Bs4ReportType46...View', props, this);
    
    React.useEffect(() => {            
      this.bs4DataProvider.on(Bs4DataProvider.DATA_LOADED, setData);
      this.bs4DataProvider.fetchMore();
      return (() => this.bs4DataProvider.off(setData));
    }, [setData])

    return (
      <Box ref={ref} height='100%' width='100%' display='flex' flexDirection='column' overflow='hidden' px={props.uxKartoteka?.spacing}>
        <Box display="flex" flexDirection='row' flexWrap='wrap' gap='6px' p={0.5} alignItems='center'>
          <Bs4Criteria {...report.props}/>
          <report.ReportBs4HorizontalMenu/>
        </Box>
        <Box pt={props.uxKartoteka?.spacing / 3}/>
        <Bs4CriteriaSummary {...report.props}/>
        <Box sx={{flex: 1, width: '100%', overflow: 'auto',}}>
          <Box
            display='grid'
            gridTemplateColumns='auto 0fr auto'
            gridTemplateRows='auto'
            sx={{width: '100%', overflow: 'hidden', ...boxSx}}
          >
            {data.map((row, index) => (
              <report.ViewRow key={row._key} row={row} index={index}/>
            ))}
          </Box>
        </Box>
        <report.bs4DataProvider.ViewPagination viewIcon/>
      </Box>
    )
  });
}